
import "./Resource.css";
import { Link } from "react-router-dom";
import SEO from '../components/seo/SEO';
import { useState } from 'react';
import { MdChevronRight, MdArticle, MdFolder } from "react-icons/md";

const networking = [
    { to: "/networking/fundamentals", label: "Network Fundamentals" },
    { to: "/networking/addressing", label: "Network Addressing" },
    { to: "/networking/access", label: "Network Access" },
    { to: "/networking/connectivity", label: "Network Connectivity" },
    { to: "/networking/automation", label: "Network Automation" },
    { to: "/networking/services", label: "Network Services" },
];

const cloud = [
    { to: "/cloud/CloudRunDeploy", label: "Deploying applications to Google Cloud Run" },
]

const tools = [
    { to: "/tools/FileConverter", label: "Convert File Format"},
    { to: "/tools/FileCompress", label: "Compress Images" }
];

export default function Resource() {
    const [openNetworking, setOpenNetworking] = useState(false);
    const [openCloud, setOpenCloud] = useState(false);
    const [openTools, setOpenTools] = useState(false)

    return (
        <>
            <SEO
                title="Resource | Explorelrt"
                description="Explore resources from Explorelrt, including practical technical learning paths and networking study material."
            />

            <main className="resourceContainer">


                <section className="resourceIntro">
                    <p>Welcome to the Academy! you can find a variety of educational resources and courses to enhance your knowledge and skills.</p>

                </section>

                <section className="Resource">

                    <div className="resourcePanel">
                        
                        <button
                            type="button"
                            onClick={() => setOpenNetworking((expand) => !expand)}
                            className="resourceHeaderButton"
                            aria-expanded={openNetworking}
                            aria-controls="resource-list"
                        >
                            <span className="resourceHeaderTitle">
                                <MdFolder aria-hidden="true" />
                                <span>Networking</span>
                            </span>
                            <MdChevronRight
                                className={`resourceToggleIcon ${openNetworking ? "open" : ""}`}
                                aria-hidden="true"
                            />
                        </button>
                        {openNetworking &&
                            <div className="resourceList" id="resource-list">
                                {networking.map((item) => (
                                    <Link key={item.to} to={item.to}>
                                        <span className="resourceListTitle">
                                            <MdArticle aria-hidden="true" />
                                            <span>{item.label}</span>
                                        </span>
                                        <MdChevronRight className="resourceListArrow" aria-hidden="true" />
                                    </Link>
                                ))}
                            </div>
                        }

                        <button
                            type="button"
                            onClick={() => setOpenCloud((expand) => !expand)}
                            className="resourceHeaderButton"
                            aria-expanded={openCloud}
                            aria-controls="resource-list"
                        >
                            <span className="resourceHeaderTitle">
                                <MdFolder aria-hidden="true" />
                                <span>Cloud Technology</span>
                            </span>
                            <MdChevronRight
                                className={`resourceToggleIcon ${openCloud ? "open" : ""}`}
                                aria-hidden="true"
                            />
                        </button>
                        {openCloud &&
                            <div className="resourceList" id="resource-list">
                                {cloud.map((item) => (
                                    <Link key={item.to} to={item.to}>
                                        <span className="resourceListTitle">
                                            <MdArticle aria-hidden="true" />
                                            <span>{item.label}</span>
                                        </span>
                                        <MdChevronRight className="resourceListArrow" aria-hidden="true" />
                                    </Link>
                                ))}
                            </div>
                        }


                        <button
                            type="button"
                            onClick={() => setOpenTools((expand) => !expand)}
                            className="resourceHeaderButton"
                            aria-expanded={openTools}
                            aria-controls="resource-list"
                        >
                            <span className="resourceHeaderTitle">
                                <MdFolder aria-hidden="true" />
                                <span>Tools</span>
                            </span>
                            <MdChevronRight
                                className={`resourceToggleIcon ${openTools ? "open" : ""}`}
                                aria-hidden="true"
                            />
                        </button>
                        {openTools &&
                            <div className="resourceList" id="resource-list">
                                {tools.map((item) => (
                                    <Link key={item.to} to={item.to}>
                                        <span className="resourceListTitle">
                                            <MdArticle aria-hidden="true" />
                                            <span>{item.label}</span>
                                        </span>
                                        <MdChevronRight className="resourceListArrow" aria-hidden="true" />
                                    </Link>
                                ))}
                            </div>
                        }
                    </div>
                </section>
            </main>
        </>
    );
}
